import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../Login/AuthContext";

const ProtectedComponent = ({ children }) => {
  const { authToken, user } = useContext(AuthContext);

  const nonPublicRender = () => {
    return (
      <h4>
        This page is not public. Please contact the admin to approve access.
      </h4>
    );
  };

  // Redirect to login if not authenticated
  return authToken ? (
    user?.role === "public" ? (
      nonPublicRender()
    ) : (
      children
    )
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedComponent;
